import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfigService } from '@app/core/config/app-config.service';

export const devEnvironmentGuard: CanActivateFn = () => {
  const config = inject(AppConfigService);
  const router = inject(Router);
  const environmentName = config.settings.environmentName?.trim().toLowerCase();

  if (environmentName === 'development') {
    return true;
  }

  return router.createUrlTree(['/']);
};
